const attemptiOSPostMessage = (handlerName: keyof WebKitMessageHandlers) => {
  if (!window.webkit?.messageHandlers) {
    return
  }

  const handler = window.webkit.messageHandlers[handlerName]

  if (typeof handler?.postMessage === "function") {
    handler.postMessage("")
  }
}

const attemptAndroidInvoke = (handlerName: keyof AndroidInterfaceMessageHandlers) => {
  if (typeof AndroidInterface === "undefined") {
    return
  }

  if (typeof AndroidInterface?.[handlerName] === "function") {
    AndroidInterface[handlerName]()
  }
}

export const closeWebview = (): void => {
  attemptiOSPostMessage("closeWebview")
  attemptAndroidInvoke("closeWebView")
}

// taken from https://stackoverflow.com/a/9039885
export const isPlatformIOS =
  [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes("Mac") && "ontouchend" in document)

export const findParentWithClassName = (
  element: HTMLElement,
  className: string,
): HTMLElement | null => {
  if (element.classList.contains(className)) {
    return element
  }

  if (element.parentElement) {
    return findParentWithClassName(element.parentElement, className)
  }

  return null
}
